import { configStore } from '@mfe/store';
import { ConsentUpdate, ConsentUpdateList, Purpose } from '@mfe/types/model';

import HttpClient from './HttpClient';

export interface ErrorResponse {
  statusCode: number; // The HTTP status code.
  error: string; // A general error name, e.g., Bad Request.
  message: string; // A more detailled error message.
}

export default class Api4pClient {
  httpClient: HttpClient;

  public constructor() {
    this.httpClient = new HttpClient({
      apiUrl: configStore.apiUrl,
      altFetchMethodName: configStore.fetch,
      accessToken: configStore.accessToken,
    });
  }

  public async getConsents(spId: string, lcId: string): Promise<Purpose[]> {
    const path = '/services/mfe/consents';
    const query = {
      lcId,
      spId,
    };

    return this.httpClient.get<Purpose[], ErrorResponse>(path, query);
  }

  public async postConsentsUpdateList(tenant: string, consents: ConsentUpdate[]) {
    const path = '/consents/update-list';
    const headers = {
      'x-tenant': tenant,
    };
    return this.httpClient.post<ConsentUpdateList, ErrorResponse>(path, { consents }, {}, headers);
  }
}
